import { get } from "../cookie";
import { siteAxios } from "./client";
import { KlarnaCreateSessionArguments, KlarnaUpdateSessionArguments, SessionResponse } from "./http";

const klarnaProxy = {
  createSession: async ({ data }: KlarnaCreateSessionArguments) => {
    const response = await siteAxios.post<SessionResponse>(
      `/api/v2/klarna/sessions`,
      data,
      {
        headers: {
          'X-Session-Key': get('secretKey')
        }
      }
    );

    return response.data;
  },
  updateSession: async ({ id, price }: KlarnaUpdateSessionArguments) => {
    const response = await siteAxios.put<SessionResponse>(
      `/api/v2/klarna/sessions/${id}`,
      { price },
      {
        headers: {
          'X-Session-Key': get('secretKey')
        }
      }
    );

    return response.data;
  }
};

export {
  klarnaProxy
};